import { defineMessages } from 'react-intl';

export const messages: {
	pageTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	whiteboardTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	pageTitle: {
		id: 'confluence.page.preview.panel.pageTitle',
		defaultMessage: 'Confluence Page',
		description: 'Page title shown in the preview panel when viewing a Confluence page.',
	},
	whiteboardTitle: {
		id: 'confluence.page.preview.panel.whiteboardTitle',
		defaultMessage: 'Confluence Whiteboard',
		description: 'Page title shown in the preview panel when viewing a Confluence whiteboard.',
	},
});
